import React from 'react';
import Layout from '../../Layout/Layout';
import { Container, Row, Col } from 'reactstrap';
import TitleBar from '../../Layout/TitleBar';
import {
  CookbookMealListEdge,
  withLoading,
  DietTypesSliderCookbookCategory,
  ListCookbookCategory,
  SliderCookbookCategory,
  CookbookTag,
  useTranslator,
} from '@front-activerse/common-components';
import CookbookMealItem from '../components/CookbookMealItem';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';

interface ICookbookMealListContainer {
  mealTypeTags: CookbookTag[];
  categories: (SliderCookbookCategory | ListCookbookCategory | DietTypesSliderCookbookCategory)[];
  categoryId?: string;
  mealTypeTagId?: string;
  meals: CookbookMealListEdge[];
  addToFavorites: (mealId: number) => Promise<unknown>;
  removeFromFavorites: (mealId: number) => Promise<unknown>;
}

export const CookbookIndexContainer: React.FC<ICookbookMealListContainer> = ({
  meals,
  addToFavorites,
  removeFromFavorites,
}) => {
  const { t } = useTranslator();
  return (
    <Layout>
      <TitleBar level={1}>{t('cookbook.filteredResults.navbarTitle')}</TitleBar>
      <div className="page-template-cookbook full-height3">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <div className="cookbook-category">
                  <Row className="cookbook-meals">
                    {meals.map(({ node }) => (
                      <CookbookMealItem
                        key={node.id}
                        {...node}
                        addToFavorites={addToFavorites}
                        removeFromFavorites={removeFromFavorites}
                        orientation="horizontal"
                      />
                    ))}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

const Placeholder = () => <UniversalPlaceholder titleBar="" />;

export default withLoading(CookbookIndexContainer, Placeholder);
